export const uidToId = (uid?: string) => {
  if (!uid) {
    return null;
  }
  return +uid.split(/users-/g)[1];
};
export const idToUid = (id: number) => `users-${id}`;
